<template>
  <div
    class="mt-2 mx-2 mb-4 pt-1 pb-2 px-1 blue-grey lighten-5 inner-attributes"
    v-if="items.length > 0"
  >
    <div
      class="text-subtitle-1 ml-2 mb-0 mt-1"
      v-if="items.length > 0"
    >
      {{ title }}
    </div>

    <location-attribute-switch
      class="ml-2"
      v-for="item in items.filter(i => i.value_type === 'BOOL')"
      :key="item.id"
      :text="item.display_name"
      :value="_.get(item, 'current_value.pivot.values', item.value)"
      v-on:change="val => updateData(val, item.item_value, item)"
    />
  </div>
</template>

<script>
import LocationAttributeSwitch from '@/views/Locations/Components/LocationAttributeSwitch'
import _ from 'lodash'

export default {
  name: "LocationAttributeSelectMultiple",
  props: {
    title: {
      type: String,
      required: true
    },
    items: Array
  },
  computed: {
    _() {
      return _
    }
  },
  components: {
    LocationAttributeSwitch,
  },
  data: () => ({
    myValue: {}
  }),
  created() {
    if (Array.isArray(this.items)) {
      this.items.forEach(item => {
        this.myValue[item.item_value] = _.get(item, 'current_value.pivot.values', item.value)
      })
    }
  },
  methods: {
    getValueInnerAttribute: function(item, value) {
      let setValues = _.get(item, 'current_value.pivot.repeated_enum_value.setValues', [])
      setValues = Array.isArray(setValues) ? setValues : []
      let unsetValues = _.get(item, 'current_value.pivot.repeated_enum_value.unsetValues', [])
      unsetValues = Array.isArray(unsetValues) ? unsetValues : []

      return setValues.includes(value)
          ? true
          : unsetValues.includes(value)
              ? false
              : null
    },
    updateData: function(a, b) {
      this.myValue[b] = a
      this.change()
    },
    change: function() {
      this.$emit('change', this.myValue)
    },
  }
}
</script>

<style scoped>
.inner-attributes {
  border-radius: 10px;
}
</style>